import {
  ChevronLeftIcon,
  ChevronRightIcon,
  SearchIcon,
  TimeIcon,
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Grid,
  GridItem,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  SimpleGrid,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { AiOutlineShopping } from "react-icons/ai";
import TransactionCard from "../components/card/TransactionCard";
import Pagination from "../components/utilities/Pagination";
import FetchData from "../services/FetchData";

export default function TransactionList() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [mobile] = useMediaQuery("(max-width: 600px)");

  const listFilterIndo = [
    "Semua",
    "Menunggu Pembayaran",
    "Sudah Dibayarkan",
    "Gagal",
  ];
  const listFilter = ["", "UNPAID", "PAID", "FAILED"];
  const defaultStatus = ["UNPAID", "PAID", "FAILED"];
  const dateNow = new Date();

  const [page, setPage] = useState(1);
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(
    dateNow.toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(dateNow.toISOString().split("T")[0]);

  const [fillterActive, setFillterActive] = useState("Semua");
  const [statusBE, setStatusBE] = useState();

  if (localStorage.getItem("access_token") === null) {
    window.location.replace("/");
  }

  console.log(data);
  console.log(statusBE);

  useEffect(() => {
    axios
      .post(
        baseURL + "/orders/history",
        {
          start_date: startDate,
          end_date: endDate,
          status: statusBE === undefined ? defaultStatus : [statusBE],
          keyword: search,
          page: page,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((res) => {
        console.log(res);
        setData(res.data.data);
      })
      .catch((error) => console.log(error));
  }, [statusBE, startDate, endDate, page, search]);

  const handleChangeStartDate = (e) => {
    const date = e.target.value;
    setStartDate(date);
  };
  const handleChangeEndDate = (e) => {
    const date = e.target.value;
    setEndDate(date);
  };
  const handleChangeStatus = (e, key) => {
    const { name, value } = e.target;
    console.log(name, value, key);
    if (key === 0) {
      setFillterActive(name);
      setStatusBE(undefined);
      return;
    }
    setFillterActive(name);
    setStatusBE(value);
  };
  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  const handlePage = (item) => {
    setPage(item);
  };

  return (
    <Box px={mobile ? "0" : "20"} py={mobile ? "0" : "10"}>
      <Text hidden={mobile} fontWeight="600" fontSize="20" py="5">
        Daftar Transaksi
      </Text>
      <Box border={!mobile && "1px solid #E0E0E0"} borderRadius="10px" p="5">
        {/* <Text>Filter</Text> */}
        <Grid templateColumns="repeat(3, 1fr)" gap={2}>
          <GridItem colSpan={2}>
            <InputGroup>
              <Input
                placeholder="Cari Transaksimu Disini (product atau perusahaan)"
                value={search}
                onChange={handleChangeSearch}
              />
              <InputRightElement
                children={
                  <IconButton variant="ghost" color="gray">
                    <SearchIcon />
                  </IconButton>
                }
              />
            </InputGroup>
          </GridItem>
          <GridItem>
            <InputGroup>
              <SimpleGrid columns={2}>
                <Input
                  type="date"
                  value={startDate}
                  onChange={handleChangeStartDate}
                />
                <Input
                  type="date"
                  value={endDate}
                  onChange={handleChangeEndDate}
                />
              </SimpleGrid>
            </InputGroup>
          </GridItem>
        </Grid>
        <HStack overflowY="auto" shouldWrapChildren>
          <Text py="5" fontWeight="600" fontSize="16">
            Status
          </Text>
          {listFilterIndo.map((item, key) => (
            <Button
              borderRadius="100px"
              variant={fillterActive === item ? "solid" : "outline"}
              color={fillterActive === item ? "#2563EB" : "gray"}
              name={item}
              value={listFilter[key]}
              fontWeight
              onClick={(e) => handleChangeStatus(e, key)}
            >
              {item}
            </Button>
          ))}
        </HStack>
        {data?.orders !== null ? (
          data?.orders.map((item, key) => (
            <TransactionCard key={key} data={item} />
          ))
        ) : (
          <Text textAlign="center" fontWeight="600" py="10">
            Tidak Ada History Order, Coba Ubah Filter
          </Text>
        )}
        <Pagination
          page={page}
          handlePage={handlePage}
          totalPage={data?.total_pages}
        />
      </Box>
    </Box>
  );
}
